import React, { useState } from 'react';
import * as Styles from './board.styles';


export const BoardMembers: React.FC = () => {
    const [selectedMember, setSelectedMember] = useState<any>(null);
  
    const handleCloseModal = () => setSelectedMember(null);

    const boardMembers = [
        {
          name: "Maxwell Flitton",
          jobTitle: "Software engineer at SurrealDB and author at O'Reilly and Packt",
          photo: "maxwell_flitton.jpeg",
          bio: `Maxwell Flitton is the author of the O’Reilly book “async rust” and the first, second, 
                and third edition of the Packt book “Rust and web programming”. He is a senior software 
                engineer at SurrealDB which is a database written in Rust. He is also an honorary researcher 
                at Kings College London focusing on building async rust interfaces with GPUs in surgical robotics. Maxwell 
                studied physics and then did his post grad dip in physics and engineering in medicine at UCL. Before studying 
                physics Maxwell completed a degree in Nursing and worked at Charing Cross Hospital Emergency Department in London.`,
        },
        {
            name: "Yang Li",
            jobTitle: "PhD student in biomedical engineering (King's College London)",
            photo: "yang.jpeg",
            bio: `Yang Li is a PhD student at King's College London, specializing in Surgical Data Science and the 
                  Internet of Surgical Things (IoST). Yang's research focuses on integrating advanced sensing and 
                  machine learning technologies to enhance surgical practice and education. In 2022, Yang graduated 
                  with a first-class BEng degree from the University of Birmingham, UK, followed by a Distinction 
                  in MSc Integrated Machine Learning Systems at UCL in 2023, where he also won the Top Project Prize. 
                  His academic journey reflects a strong foundation in machine learning, robotics, and IoT. Yang has 
                  contributed to diverse projects, including human pose estimation and gesture classification for 
                  robotic dog control, consumer IoT device security, and his current work on IoST technologies. 
                  His efforts have led to three peer-reviewed publications:
                  Quarez, J, Li Y, et al. "MUTUAL: Towards Holistic Sensing and Inference in the Operating Room." 
                  Medical Image Computing and Computer-Assisted Interventions (MICCAI) (2024).
                  Li, Y, et al. "AI solutions for overcoming delays in telesurgery and telementoring to enhance 
                  surgical practice and education." Journal of Robotic Surgery 18(1): 403 (2024).
                  Li, Y, Mandalari AM, and Straw I. "Who let the smart toaster hack the house? An investigation 
                  into the security vulnerabilities of consumer IoT devices." arXiv preprint arXiv:2306.09017 (2023).`,
          },
        {
        name: "Christos Bergeles",
        jobTitle: "Professor of Surgical Robotics (King's College London)",
        photo: "christos.jpg",
        bio: `Prof Christos Bergeles received his Ph.D. degree in Robotics from ETH Zurich, Switzerland, in 2011. 
              He was a postdoctoral research fellow at Boston Children’s Hospital, Harvard Medical School, 
              Massachusetts, and the Hamlyn Centre for Robotic Surgery, Imperial College, United Kingdom. As a 
              Professor at King’s College London, he directs the “Robotics and Vision in Medicine Lab” whose mission 
              is to develop micro-surgical robots that deliver regenerative therapies deep inside the human body. 
              Prof Bergeles has been awarded an ERC Starting Grant (2017 – 2023) and, among others, holds i4i NIHR 
              funding (2017 – 2020, 2022 – 2025) for the development of instrumentation that delivers stem cells 
              to diseased retinal layers. His active grant funding as PI is £2.5M. He has co-authored more than 
              100 articles in top-tier conferences and journals, and his research has been cited more than 3000 
              times. He was an Associate Editor of the IEEE Transactions on Robotics, and the IEEE Int. Conf. 
              Robotics and Automation. His team and he are very active in public engagement and patient involvement 
              activities, with examples including New Scientist Live (2019, 2023, 10,000+ participants), and Royal 
              Society Summer Science Exhibition (2023, 10,000+ participants). He is an IEEE Senior Member.`,
        },
        {
          name: "Alexandru Radovici",
          jobTitle: "Associate Professor teaching operating systems and embedded systems in Rust (Politehnica University of Bucharest) and founder of OxidOS",
          photo: "Alexandru.jpg",
          bio: `Co-founder of OxidOS Automotive & Wyliodrin and Associate Professor at Politehnica University of 
                Bucharest. Alexandru Radovici has introduced Rust in the Romanian universities, teaching Operating 
                Systems and Embedded Systems in Rust and an Introduction to Rust course. While serving as CEO of 
                Wyliodrin and currently OxidOS, Alexandru has deployed Rust to industrial and automotive systems, 
                using Tokio, Tauri, Slint and other cutting edge technologies. In his spare time, Alexandru is a 
                core contributor to the Tock Operating System. He has published on of the first books about using 
                Rust in embedded systems, Getting Started with Secure Embedded Systems using Tock.`,
        },
        {
          name: "Nick Chen",
          jobTitle: "Lead investor at Golden Ventures",
          photo: "nick_chen.jpg",
          bio: `Nick leads all AI and deep-tech investing at Golden Ventures. He previously built and led the 
                corporate venture arm of IEX, a top-5 US stock exchange, where he invested in early-stage 
                companies aligned with the company’s digital assets strategy. As a member of IEX’s leadership 
                team, Nick played a pivotal role in shaping the company’s entry into the digital assets market, 
                and helped to design and stand up multiple “frontier” business units. Nick began his venture 
                career as an investor at Georgian, an R&D-focused VC firm investing in growth-stage Applied AI 
                companies. During his 6-year tenure, Nick led the development of key investment theses focused 
                on AI and web3. He also developed the structure for the “Pathfinder” program to invest in early-stage 
                emerging technology deals across key thesis areas.`,
        },
        {
          name: "Lucy Wan",
          jobTitle: "Publishing Product Manager at Packt Publishing",
          photo: "lucy_wang.jpg",
          bio: `Lucy Wan manages a portfolio of technical books at Packt, a global publisher that produces resources for IT 
                professionals at all stages of their careers. She works closely with authors, readers, and techpros to figure 
                out how to design useful learning resources. Lucy holds a bachelor's degree in Mathematics and a master's in 
                Systems Biology from the University of Cambridge - both disciplines she swears she'll get back to in the future.`,
          },
        {
          name: "Lawrence Adams",
          jobTitle: "Data Engineer at London AI Centre (King's College London)",
          photo: "lawrence_adams.jpeg",
          bio: `Lawrence is an ex-medical doctor for several years and life long programmer who now works at the London 
                AI Centre as a data engineer passionate about improving the use of medical data for research, 
                but having become increasingly disillusioned with other languages tries to utilise rust and rust 
                based tools wherever he can!`,
        },
        {
          name: "Zak Siddiq",
          jobTitle: "PhD student in computational chemical engineering (University of Nottingham)",
          photo: "zak.png",
          bio: `Zak Siddiq is a PhD student specializing in computational chemical engineering at the 
                University of Nottingham, focusing on software development to enhance process development 
                and environmental safety. He earned his undergraduate degree in Chemical Engineering and a 
                joint master's degree in Mathematics and Chemical Engineering from the University of 
                Loughborough. Zak has contributed as a consultant for MonolithAI and as a Software Engineer 
                for Syngenta, where he developed transformer models. During his PhD, he also served as the CTO
                 of the Imperial College London startup, PebbleSense, acting as a full-stack engineer and 
                 spokesperson at the startup accelerator KQ-LABS`,
        },
        {
            name: "Torath Ameen",
            jobTitle: "Consultant Robotic Surgeon (translating engineering into practice)",
            photo: "torath.png",
            bio: `Dr. Torath Ameen is a consultant robotic surgeon in the NHS, specializing in advanced urological 
                  procedures and innovation in healthcare. With extensive experience in clinical AI, he integrates 
                  cutting-edge technology to enhance surgical precision and patient outcomes. Currently pursuing an 
                  Executive MBA at University College London, he combines clinical expertise with strategic leadership 
                  to drive transformative healthcare solutions. A passionate advocate for innovation, Torath 
                  contributes to advancing research, education, and AI-driven approaches in surgical practice.`,
        },
    ];
  
    return (
      <Styles.BoardContainer>
        <h1>Our Board Members</h1>
        <Styles.Grid>
          {boardMembers.map((member, index) => (
            <Styles.Card key={index} onClick={() => setSelectedMember(member)}>
              <Styles.ProfilePhoto src={member.photo} alt={member.name} />
              <Styles.Name>{member.name}</Styles.Name>
              <Styles.JobTitle>{member.jobTitle}</Styles.JobTitle>
            </Styles.Card>
          ))}
        </Styles.Grid>
        {selectedMember && (
          <Styles.ModalOverlay onClick={handleCloseModal}>
            <Styles.ModalContent onClick={(e) => e.stopPropagation()}>
              <Styles.ModalCloseButton onClick={handleCloseModal}>&times;</Styles.ModalCloseButton>
              <Styles.ProfilePhoto src={selectedMember.photo} alt={selectedMember.name} />
              <Styles.Name>{selectedMember.name}</Styles.Name>
              <Styles.JobTitle>{selectedMember.jobTitle}</Styles.JobTitle>
              <p>{selectedMember.bio}</p>
            </Styles.ModalContent>
          </Styles.ModalOverlay>
        )}
      </Styles.BoardContainer>
    );
  };